import { Component, OnInit, Input, ViewChild, OnDestroy, ElementRef, HostBinding } from '@angular/core';
import { Production, VOD, Podcast, User } from 'models';
import { PlayerComponent } from '../player/player.component';
import { UserService } from 'user';
import { SubscriptionSet } from 'common';

@Component({
  selector: 'tyt-show-production-view',
  templateUrl: './show-production-view.component.html',
  styleUrls: ['./show-production-view.component.scss']
})
export class ShowProductionViewComponent implements OnInit, OnDestroy {

  constructor(
    private userService : UserService,
    private elementRef : ElementRef
  ) { }
  
  @Input() 
  public production : Production;

  @Input() 
  public mode : "clips" | "episodes" | "podcasts";

  @Input() 
  public includeShowName : boolean = false;

  @Input()
  public limit = 1;

  sessions = {};
  user : User = null;

  @Input()
  main: boolean = false;

  get linkToWatchFirstItem() {
    if (this.items && this.items.length > 0 && this.production) {
      let firstItem = this.items[0];
      return `/watch/${this.production.show.slug || this.production.show.id}/${this.production.id}/${this.modeForItem(firstItem)}/${firstItem.id}`;
    }

    return `/shows/${this.production.show.id}`;
  }

  get date() {
    if (!this.production)
      return '';
    
    return this.production.date_simple;
  }

  get featuredClip() {
    if (!this.production) {
      return null;
    }
    return this.production.featured_clip;
  }

  get completeShow() {
    if (!this.production) {
      return null;
    }
    return this.production.full_length_vods[0];
  }

  get mainShowClip() {
    return this.featuredClip || this.production.vod_clips[0];
  }

  modeForItem(item: VOD) {
    if (!item) {
      return this.mode;
    }
    if (this.main) {
      if (this.production.vod_clips.find((vod) => vod.id == item.id)) {
        return 'clips';
      }
      if (this.production.full_length_vods.find((episode) => episode.id == item.id)) {
        return 'episodes';
      }
      if (this.production.full_length_podcasts.find((podcast) => podcast.id == item.id)) {
        return 'podcasts';
      }
    } 
    return this.mode;
  }


  get items() {

    if (this.main) {
      if (this.featuredClip) {
        return [this.featuredClip]
      }

      if (this.production.full_length_vods && this.production.full_length_vods.length > 0)
        return [this.production.full_length_vods[0]];
      
      if (this.production.vod_clips && this.production.vod_clips.length > 0)
        return [this.production.vod_clips[0]];
      
    }
    
    let items = [];
    if (this.mode == 'clips') {
      items = <any> this.production.vod_clips;
    } else if (this.mode == 'episodes') {
      items = <any> this.production.full_length_vods;
    } else if (this.mode == 'podcasts') {
      items = <any> this.production.full_length_podcasts;
    }

    if (this.limit > 0) {
      items = items.slice(0, this.limit);
    }

    return items;
  }

  subscriptions : SubscriptionSet = new SubscriptionSet();
  audienceType : string = 'visitor';

  ngOnInit() {
    this.subscriptions.subscribe(this.userService.userChanged, user => this.user = user);

    this.audienceType = this.userService.audienceType;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribeAll();
  }

}
